module.exports = __webpack_public_path__ + "img/radio_check.97256fa6.svg";